import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, SuperAdminRoute } from './components/ProtectedRoute';
import { AdminLayout } from './components/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { RoleChangeRequestsPage } from './pages/RoleChangeRequestsPage';
import { ActivityLogsPage } from './pages/ActivityLogsPage';
import { SchoolsPage } from './pages/SchoolsPage';
import { RegisterSchoolPage } from './pages/RegisterSchoolPage';
import { ClassesPage } from './pages/ClassesPage';
import { ClassContentPage } from './pages/ClassContentPage';
import { CharacterPillarsPage } from './pages/CharacterPillarsPage';
import { BadgesPage } from './pages/BadgesPage';
import { RegistrationPage } from './pages/RegistrationPage';
import { RegistrationFormEditorPage } from './pages/RegistrationFormEditorPage';
import { PublicApplyPage } from './pages/PublicApplyPage';
import { SettingsPage } from './pages/SettingsPage';
import { ProfilePage } from './pages/ProfilePage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/apply/:formId" element={<PublicApplyPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/role-change-requests" element={<RoleChangeRequestsPage />} />
              <Route path="/schools" element={<SchoolsPage />} />
              <Route path="/schools/register" element={<RegisterSchoolPage />} />
              <Route path="/classes" element={<ClassesPage />} />
              <Route path="/content" element={<ClassContentPage />} />
              <Route path="/registration" element={<RegistrationPage />} />
              <Route path="/registration/forms/new" element={<RegistrationFormEditorPage />} />
              <Route
                path="/registration/forms/:formId/edit"
                element={<RegistrationFormEditorPage />}
              />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/preferences" element={<Navigate to="/settings" replace />} />
              <Route
                path="/change-password"
                element={<Navigate to="/settings#change-password" replace />}
              />
              <Route element={<SuperAdminRoute />}>
                <Route path="/activity-logs" element={<ActivityLogsPage />} />
                <Route path="/character-pillars" element={<CharacterPillarsPage />} />
                <Route path="/badges" element={<BadgesPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
